import { tv } from "@opensea/ui-kit"

export const mintModuleContentClasses = tv({
  base: "col-span-12 gap-6 lg:col-span-7",
  variants: {
    hasPreviewImages: {
      false: "lg:col-span-8",
    },
  },
  defaultVariants: {
    hasPreviewImages: true,
  },
})

export const mintStageIndicator = tv({
  base: "flex size-6 shrink-0 items-center justify-center rounded-full border border-border-1 bg-bg-additional-2",
  variants: {
    isPastStage: {
      true: "bg-success-1",
    },
    isActiveStage: {
      true: "border-success-1",
    },
  },
  defaultVariants: {
    isPastStage: false,
    isActiveStage: false,
  },
})

export const stageEligibilityTextClasses = tv({
  base: "font-mono uppercase",
  variants: {
    isEligible: {
      true: "text-success-1",
      false: "text-text-tertiary",
    },
  },
})

export const mintScheduleRowClasses = tv({
  base: "items-center",
  variants: {
    isActiveStage: {
      false: "opacity-60",
    },
  },
})
